export interface ShowAllLabels {
  /** Tooltip + aria-label for the collapse (✕) button shown while expanded. */
  toggle: string
}

export const DEFAULT_SHOW_ALL_LABELS: ShowAllLabels = {
  toggle: 'Show less',
}
